import React from 'react'

import { Toast, Typography } from '@chilecompra/react-kit/components'

/**
 * The Quote List Purchase Order's disclaimer.
 */
const QuoteListPurchaseOrderDisclaimer = () => {
  return (
    <Toast margin="4px 0">
      <Typography color="black2" variant="body2">
        El organismo público ha generado las órdenes de compra correspondientes y su envío se encuentra pendiente. Una
        vez enviadas al proveedor, serán visibles en esta sección.
      </Typography>
    </Toast>
  )
}

export default QuoteListPurchaseOrderDisclaimer
